'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { BookOpen, Circle, ClipboardList, Frame, House, Images, LayoutGrid, Megaphone, Sparkles, Star, Sunrise, Trophy, } from 'lucide-react';
/**
 * The catalog's icon names, keyed exactly as the seed spells them. lucide emits
 * inline stroke SVGs with viewBox="0 0 24 24", stroke-width 2 and round caps,
 * which is the icon contract verbatim — nothing here draws its own paths.
 */
const ICONS = {
    house: House,
    sunrise: Sunrise,
    star: Star,
    sparkles: Sparkles,
    frame: Frame,
    'book-open': BookOpen,
    megaphone: Megaphone,
    'clipboard-list': ClipboardList,
    trophy: Trophy,
    images: Images,
    'layout-grid': LayoutGrid,
};
/** An unrecognised icon name degrades to a neutral circle rather than an empty chip. */
function NavIcon({ name, size = 16, className = 'ahsuite-icon' }) {
    const Icon = ICONS[name] ?? Circle;
    return _jsx(Icon, { "aria-hidden": "true", className: className, width: size, height: size, strokeWidth: 2 });
}
/** The waffle: hide control in the bar, restore affordance in NavTrigger. */
function WaffleIcon({ size = 24, className = 'ahsuite-icon' }) {
    return _jsx(LayoutGrid, { "aria-hidden": "true", className: className, width: size, height: size, strokeWidth: 2 });
}
export { NavIcon, WaffleIcon };
//# sourceMappingURL=icons.js.map